import React, { useContext } from 'react';
import styles from './index.module.scss';
import { toJSX } from 'src/utils/toJSXHelper';
import { I18nContext } from 'src/stores/I18n';
import { LOCALE_TYPE } from 'src/types/locale';
import { generateQuestionnaireURL } from 'src/components/shared/templates/questionnaire/utils';
import { useRouter } from 'next/router';
import { mixpanel } from 'src/utils/mixpanel';
import { PointerIcon } from 'src/components/shared/elements/icons/PointerIcon';
import { CursorIcon } from 'src/components/shared/elements/icons/CursorIcon';

type Props = {
  mixpanelEventType?: 'popup' | 'footer' | 'sticker';
};

export const QuestionnaireSticker: React.FC<Props> = ({ mixpanelEventType = 'footer' }) => {
  const { locale, asPath } = useRouter();
  const questionnaireLink = generateQuestionnaireURL(locale as LOCALE_TYPE);
  const localeResources = useContext(I18nContext);
  const handleClick = (): void => mixpanel.onQuestionnaireLinkClicked(mixpanelEventType, asPath);
  return (
    <div className={styles.container}>
      <p>{toJSX(localeResources.questionnaire.popup(questionnaireLink, styles.link), handleClick)}</p>
      <div className={styles.mobileOnly}>
        <PointerIcon />
      </div>
      <div className={styles.desktopOnly}>
        <CursorIcon />
      </div>
    </div>
  );
};
